import {
    FETCH_POLICIES_REQUEST,
    FETCH_POLICIES_SUCCESS,
    FETCH_POLICIES_FAILURE,
} from "./types";

import {
    fetchPolicies,
} from "../../services/policyService";

export const fetchPoliciesAction =
    () =>
    async (
        dispatch
    ) => {

        dispatch({
            type:
                FETCH_POLICIES_REQUEST,
        });

        const result =
            await fetchPolicies();

        if (
            result.success
        ) {
            dispatch({
                type:
                    FETCH_POLICIES_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    FETCH_POLICIES_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };